import axios from 'axios';

// Em desenvolvimento: usa proxy do package.json (/api -> localhost:8000/api)
// Em producao: usa REACT_APP_API_URL definida nas variaveis do Netlify
const BASE_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(config => {
  // Token auth -- necessario no iOS Safari (cookies cross-origin bloqueados pelo ITP)
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = `Token ${token}`;

  // CSRF -- fallback para sessao no desktop
  const csrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrftoken='))
    ?.split('=')[1];
  if (csrfToken) config.headers['X-CSRFToken'] = csrfToken;

  // FormData: remover Content-Type para o browser setar multipart/form-data
  // com o boundary correto automaticamente. O default 'application/json' do
  // axios instance quebraria o multipart parsing no backend (400 Arquivo não enviado).
  // Em axios 1.x, config.headers é um AxiosHeaders — usar .delete() em vez do
  // operador delete, que pode não remover o header por normalização interna de casing.
  if (config.data instanceof FormData) {
    if (typeof config.headers?.delete === 'function') {
      config.headers.delete('Content-Type');
    } else {
      delete config.headers['Content-Type'];
    }
  }

  return config;
});

export default api;
